import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BrandLogo from "./component/BrandLogo";
import Navigation from "./component/Navigation";
import UserActions from "./component/UserAction";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Check if we're on the home page
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    // Force scrolled state on non-home pages
    if (!isHomePage) {
      setIsScrolled(true);
      return;
    }

    const handleScroll = () => {
      // Transition header when user scrolls past 50px
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    // Initial check
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  return (
    <div
      className={`fixed z-[100] w-full transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${
        isScrolled
          ? "py-3 bg-white/90 backdrop-blur-xl border-b border-outline-variant/10 shadow-[0_10px_30px_rgba(27,28,23,0.03)]"
          : "py-6 bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto">
        <header
          className={`px-5 xl:px-20 lg:px-12 md:px-8 flex justify-between items-center transition-all duration-500`}
        >
          {/* Desktop Navigation */}
          <div className="hidden lg:block flex-1">
            <Navigation isScrolled={isScrolled} />
          </div>

          {/* Logo - Centered for spiritual balance */}
          <div className="flex-shrink-0 flex items-center justify-center">
            <BrandLogo isScrolled={isScrolled} />
          </div>

          {/* Actions & Mobile Nav */}
          <div className="flex-1 flex justify-end items-center gap-4">
            <UserActions isScrolled={isScrolled} />
            <div className="lg:hidden">
              <Navigation isScrolled={isScrolled} />
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};

export default Header;
